import { api } from "boot/axios";
import useTools from "src/use/tools";

export const getMainMenu = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api
      .get("/site/main-menu/")
      .then((res) => {
        resolve(res);
        commit("updateMainMenu", res.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getFavouriteMenu = ({ commit }) => {
  return new Promise((resolve, reject) => {
    useTools()
      .getFavMenu()
      .then((res) => {
        resolve(res);
        commit("updateFavMenu", res.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getGeneralMenu = ({ commit }) => {
  return new Promise((resolve, reject) => {
    useTools()
      .getMainMenu()
      .then((res) => {
        resolve(res);
        commit("updateGeneralMenu", res.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
